import { useTranslation } from "react-i18next";
import { STATUS_IDS, USER_ROLES_IDS } from "../../../constants/common"
import { useLocation } from "react-router-dom";
import useAuthStore from "../../../store/Auth";
import CheckboxInput from "../../../components/inputs/CheckboxInput";
import { Dispatch, SetStateAction, useMemo } from "react";
import { APP_ROUTES } from "../../../routes";

interface AcknowledgementProps {
    pcPermit?: {
        n_ApprovalStatus: number;
    };
    isAccompanyPledge: boolean;
    setIsAccompanyPledge: Dispatch<SetStateAction<boolean>>
    isPermitApprovedByNextApprover: boolean;
    isFieldsDisabled: boolean;
}

const Acknowledgement = ({
    pcPermit,
    isAccompanyPledge,
    setIsAccompanyPledge,
    isPermitApprovedByNextApprover,
    isFieldsDisabled,
}: AcknowledgementProps) => {
    const { t } = useTranslation();

    const location = useLocation();

    const { user } = useAuthStore()

    const searchParams = new URLSearchParams(location.search);

    const key = searchParams.get("ID");

    const isApprovePermitPage = useMemo(
        () => location.pathname === APP_ROUTES.APPROVE_PC_IN_OUT_PERMIT,
        [location.pathname]
    );

    return (
        <>
            {user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                (key && isApprovePermitPage ? (
                    <></>
                ) : (
                    <div className="flex flex-col gap-3 bg-white p-4 rounded-xl shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
                        <CheckboxInput
                            id="accompany-pledge"
                            label={`${t("iEmployee")} ${user?.firstname} ${user?.lastname
                                } ${t("employeePledgeToNotConnectDeviceToNetwork")}`}
                            labelStyles="leading-[1.2]"
                            checked={
                                isAccompanyPledge ||
                                isPermitApprovedByNextApprover ||
                                (user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                    isFieldsDisabled)
                            }
                            setChecked={setIsAccompanyPledge}
                            readOnly={
                                (pcPermit &&
                                    pcPermit.n_ApprovalStatus !== STATUS_IDS.PENDING) ||
                                isPermitApprovedByNextApprover ||
                                (user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                    isFieldsDisabled)
                            }
                        />
                    </div>
                ))}
        </>
    )
}

export default Acknowledgement
